import RootLayout from "@/app/layout";
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';
import { Typography, Grid, Container, Box } from '@mui/material';
import data from '../../data/beruf/data.json';
import Head from "next/head";
import Image from "next/image";

export const metadata = {
  title: 'Hebamme Lea Stiffler | Beruf',
  description: 'Erfahren Sie mehr über die Rolle einer Hebamme. Umfassende Unterstützung und Beratung für werdende Eltern während der Schwangerschaft, Geburt und im Wochenbett.',
  keywords: 'Hebamme, Chur, Schwangerschaftsbetreuung, Geburtsbegleitung, Wochenbettbetreuung, Schwangerschaftsvorsorge, Stillberatung, Geburtsvorbereitung',
  canonicalUrl: 'https://hebamme-leastiffler.ch/beruf'
}

export async function getStaticProps() {
  return { props: { data } }
}

export default function Beruf({ data }) {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });
  return (
    <RootLayout>
      <Head>
        <title>{metadata.title}</title>
        <meta name="description" content={metadata.description} />
        <meta name="keywords" content={metadata.keywords} />
        <link rel="canonical" href={metadata.canonicalUrl} />
      </Head>
      <motion.section
        className="section-large"
        ref={ref}
        initial={{ opacity: 0 }}
        animate={{ opacity: inView ? 1 : 0 }}
        transition={{ duration: 1 }}
      >
        <div className="section-body">
          <Container maxWidth="lg">
            {data.Abschnitte.map((a, index) => (
              <div key={index} style={{ marginBottom: '2rem' }}>
                <Typography variant="h3" component="h1" gutterBottom align="center">
                  {a.Titel}
                </Typography>
                <Grid container spacing={2}>
                  {a.Inhalt.map((i, index) => (
                    <Grid item xs={12} key={index}>
                      <Typography variant="h6" component="h2" sx={{ mt: 2 }}>
                        {i.Untertitel}
                      </Typography>
                      <Typography variant="body1" color="text.secondary" paragraph>
                        {i.Text}
                      </Typography>
                    </Grid>
                  ))}
                </Grid>
              </div>
            ))}
            <div className="centered-box">
              <Box sx={{ width: 'fit-content', height: 'fit-content', display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '1rem' }}>
                <Image src={data.Bild} width={1000} height={1000} alt="Logo Hebamme Lea Stiffler" />
              </Box>
            </div>
          </Container>

        </div>
      </motion.section>
    </RootLayout>
  );
}
